/* eslint-disable @angular-eslint/no-output-rename */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { FPGroupRow, GroupKey } from '../../services/financial-planning.service';
import { CloneReportingGroupKeyResource } from 'src/app/client-api.service';

@Component({
  selector: 'app-clone-group-key',
  templateUrl: './clone-group-key.component.html',
  styleUrls: ['./clone-group-key.component.scss']
})
export class CloneGroupKeyComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() fpGroupRows: FPGroupRow[] | undefined;
  @Input() groupToClone: GroupKey | undefined;
  @Input() allGropus: GroupKey | undefined;
  @ViewChild('newGroupKey') newGroupKey: ElementRef<HTMLInputElement> | undefined;
  @ViewChild('newGroupName') newGroupName: ElementRef<HTMLInputElement> | undefined;

  @Output('clone') clone: EventEmitter<any> = new EventEmitter<GroupKey>();
  
  errormessage = '';
  showSaveButton = false;
  isDuplicate = false;

  constructor() {
  }

  ngOnInit(): void {
    this.errormessage = '';
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngAfterViewInit(){
    this.newGroupName!.nativeElement.value = this.groupToClone?.name!;
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnChanges() {
    if(this.newGroupName) {
      this.newGroupName!.nativeElement.value = this.groupToClone?.name!;
    }
  }

  cloneGroupKey() {
    // eslint-disable-next-line max-len
    if(confirm('Are you sure you want to clone ' + this.groupToClone + ' and all its menbers to ' + this.newGroupName!.nativeElement.value)) {
      const cgk: CloneReportingGroupKeyResource = {
        originalGroupKey: this.groupToClone?.groupKey!,
        groupKey: this.newGroupKey?.nativeElement.value!,
        name: this.newGroupName?.nativeElement.value!
      };
      this.clone.emit(cgk);
    }
  }

  fieldChanged(elem: HTMLInputElement) {
    if(this.fpGroupRows) {
      const rows = this.fpGroupRows.filter(g => g.groupKey === elem.value);
      if(rows.length > 0) {
        this.isDuplicate = true;
        this.showSaveButton = false;
      }
      else {
        this.isDuplicate = false;
        this.showSaveButton = true;
      }
    }
  }

  getShowSaveButton() {
    return this.showSaveButton;
  }

  onDirectionEvent(elem: HTMLInputElement, evt: KeyboardEvent) {
    let moveFocus = true;
    let nextElemId = '';

    switch (evt.key) {
      case 'Tab':
        if (elem.id === 'newGroupKey') {
          nextElemId = 'newGroupName';
          moveFocus = true;
        }
        else if (elem.id === 'newGroupName') {
          nextElemId = 'newGroupKey';
          moveFocus = true;
          }
        break;
    }

    if (moveFocus === true) {
      document.getElementById(nextElemId)?.focus();
    }
  }
}
